import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  Area,
  ClientDetails,
  ClientListOption,
  ClientRetentionEntry,
  ClientRetentionOverviewSort,
  ClientsSort,
  ICreateClientParams,
  IGetClientResponse,
  IGetClientsListResponse,
  IGetClientsResponse,
} from './interfaces';
import {
  IDeleteResourceResponse,
  IGetListResponse,
  IPaginatedResourceEndpointResponse,
  IUpsertResourceResponse,
} from '../interfaces';
import { getPaginatedEndpointParams } from '../helpers';
import { FilterFields } from '../../components/ManagedDataTable/interfaces';

export const getClient = async (id: number): Promise<ClientDetails> => {
  const response: AxiosResponse<IGetClientResponse> = await apiClient.get(
    `/clients/${id}`
  );

  return response.data.data;
};

export const deleteClient = async (id: number): Promise<void> => {
  const response: AxiosResponse<IDeleteResourceResponse> =
    await apiClient.delete(`/clients/${id}`);
};

export const getClients = async (
  page: number,
  pageSize: number,
  sort?: ClientsSort,
  search?: string,
  filters?: FilterFields
): Promise<IGetClientsResponse> => {
  const response: AxiosResponse<IGetClientsResponse> = await apiClient.get(
    '/clients',
    {
      params: getPaginatedEndpointParams({
        page,
        perPage: pageSize,
        sort,
        search,
        filters,
      }),
    }
  );

  return response.data;
};

export const createClient = async (
  clientData: ICreateClientParams
): Promise<number> => {
  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.post(
    '/clients/',
    JSON.stringify(clientData),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data.data.id;
};

export const updateClient = async (
  clientId: number,
  clientData: ICreateClientParams
): Promise<number> => {
  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.put(
    `/clients/${clientId}`,
    JSON.stringify(clientData),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data.data.id;
};

export const getClientsList = async (): Promise<ClientListOption[]> => {
  const response: AxiosResponse<IGetClientsListResponse> = await apiClient.get(
    '/clients/list'
  );

  return response.data.data;
};

export const getAgentClientList = async (
  agentId: number
): Promise<ClientListOption[]> => {
  const response: AxiosResponse<IGetClientsListResponse> = await apiClient.get(
    `/agents/${agentId}/clients/list`
  );

  return response.data.data;
};

export const getAreasList = async (): Promise<Area[]> => {
  const response: AxiosResponse<IGetListResponse<Area>> = await apiClient.get(
    '/clients/areas/list'
  );

  return response.data.data;
};

export const getClientRetentionOverview = async (
  page: number,
  pageSize: number,
  sort?: ClientRetentionOverviewSort,
  search?: string,
  filters?: FilterFields
): Promise<IPaginatedResourceEndpointResponse<ClientRetentionEntry>> => {
  const response: AxiosResponse<
    IPaginatedResourceEndpointResponse<ClientRetentionEntry>
  > = await apiClient.get('/clients/retention-overview', {
    params: getPaginatedEndpointParams({
      page,
      perPage: pageSize,
      sort,
      search,
      filters,
    }),
  });

  return response.data;
};
